import { FormControl, Input, InputAdornment, InputLabel, MenuItem, Select } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import joi from 'joi';
import $ from 'jquery';
import { useTranslation } from 'react-i18next';
import { faPrint, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@mui/material/Button';
import { PrintReceiptModal } from '../receipts/PrintReceiptModal';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

export default function RequestPaymentsFields({
    requestData,
    setRequestData,
    requestDataRow,
    setRequestDataRow,
    handleChange,
    clearPaymentRows,
    // showPrintModal,
    // setShowPrintModal,
    // printType,
    // setPrintType,
    // setSelectedDeposit,
    // setSelectedRefund,
    // selectedDeposit,
    // selectedRefund
}) {

    const [showPrintModal, setShowPrintModal] = useState(false);
    const [printType, setPrintType] = useState('deposit');
    const [selectedDeposit, setSelectedDeposit] = useState(null);
    const [selectedRefund, setSelectedRefund] = useState(null);
    const [oldestPayment, setOldestPayment] = useState([]);
    const [paymentRows, setPaymentRows] = useState([
        {
            id: 1,
            paymentType: "deposit",
            paymentMethod: "",
            amountPaid: 0,
            referenceNumber: "",
            createdAt: moment().toISOString(),
        }
    ]);

    const { t, i18n } = useTranslation();

    function generatePaymentId(paymentType, code, index) {
        // deposit -> DEP-{code}-{index}
        // refund  -> REF-{code}-{index}
        const prefix = paymentType === "deposit" ? "DEP" : "REF";
        return `${prefix}-${code}-${index + 1}`;
    }

    const addNewReqPayment = () => {
        if (handleData()) {
            const newRow = { id: paymentRows.length ? paymentRows[paymentRows?.length - 1].id + 1 : 1, paymentType: "deposit", paymentMethod: "", amountPaid: 0, referenceNumber: "", createdAt: moment().toISOString() };
            setPaymentRows(prevRows => [...prevRows, newRow]);
        }
    };

    const deleteRow = id => {
        setPaymentRows(prevRows => prevRows.filter(row => row.id !== id));
    };

    const handlePaymentMethodChange = (e, id) => {
        setPaymentRows(prevRows =>
            prevRows.map(row => (row.id === id ? { ...row, paymentMethod: e.target.value } : row))
        );
    };

    function getAmountPaidTotal(payments) {
        let totalDeposits = 0;
        let totalRefunds = 0;
        payments?.forEach((ele) => {
            if (ele.paymentType === "deposit") {
                totalDeposits += parseFloat(ele.amountPaid) || 0;
            } else if (ele.paymentType === "refund") {
                totalRefunds += parseFloat(ele.amountPaid) || 0;
            }
        });
        return { totalDeposits, totalRefunds, netTotal: totalDeposits - totalRefunds };
    }

    const handleAmountPaidChange = (e, id) => {
        const inputValue = parseFloat(e.target.value);
        const currentRow = paymentRows.find(row => row.id === id);

        if (currentRow?.paymentType === 'refund') {
            // Calculate total deposits excluding current row if it's being modified
            const otherRows = paymentRows.filter(row => row.id !== id);
            const { netTotal } = getAmountPaidTotal(otherRows);

            // Limit refund to not exceed total deposits
            const maxRefundAmount = netTotal;
            const validatedAmount = inputValue > maxRefundAmount ? maxRefundAmount : inputValue;

            setPaymentRows(prevRows =>
                prevRows.map(row => (row.id === id ? { ...row, amountPaid: validatedAmount } : row))
            );
        } else {
            setPaymentRows(prevRows =>
                prevRows.map(row => (row.id === id ? { ...row, amountPaid: inputValue } : row))
            );
        }
    };

    const handleReferenceNumberChange = (e, id) => {
        setPaymentRows(prevRows =>
            prevRows.map(row => (row.id === id ? { ...row, referenceNumber: e.target.value } : row))
        );
    };

    const handlePaymentTypeChange = (e, id) => {
        setPaymentRows(prevRows =>
            prevRows.map((row, i) => (row.id === id ? { ...row, paymentType: e.target.value } : row))
        );
    };

    // function handleChange(e, id, newValue) {
    //     // deep copy
    //     let myData;
    //     requestDataRow ? myData = { ...requestDataRow } : myData = { ...requestData };
    //     // update data
    //     if (id === "paymentMethod") {
    //         myData[id] = e.target.value;
    //     } else {
    //         myData[e.target.id] = e.target.value;
    //     }
    //     // set new data
    //     console.log(myData);
    //     requestDataRow ? setRequestDataRow(myData) : setRequestData(myData);
    // }

    function handleData() {
        let validBroadcastTime = false;
        for (let i = 0; i < paymentRows.length; i++) {
            if ((paymentRows.length === 1 && i == 0 && paymentRows[i].paymentMethod) || (i >= 0 && paymentRows[i].paymentMethod && paymentRows[i].amountPaid > 0)) {
                $(".requestPaymentsError").addClass("d-none");
                validBroadcastTime = true;
            } else {
                $(".requestPaymentsError").removeClass("d-none");
                validBroadcastTime = false;
            }
        }

        if (validBroadcastTime) {
            const newData = {
                paymentType: "",
                paymentMethod: "",
                amountPaid: 0,
                referenceNumber: "",
                createdAt: moment().toISOString(),
            }
            return newData;
        } else {
            return false;
        }
    }

    // Convert formData to BookingRequest for printing
    const getBookingRequestForPrint = () => {
        const myData = requestDataRow ? { ...requestDataRow } : { ...requestData };
        console.log(myData);

        return {
            reqCode: myData.reqCode,
            clientName: myData.reqClientName,
            phone: myData.client?.clientPhone || myData?.clientPhone || myData.rentingUser?.phoneNumber,
            checkIn: myData.reqFrom,
            checkOut: myData.reqTo,
            unitName: myData.unit?.unitName || '',
            unitCode: myData.unit?.unitCode || '',
            guests: parseInt(myData.reqGuests) || 0,
            totalAmount: myData?.reqTotalCost || 0,
            deposits: myData.reqPayments,
            refunds: myData.reqPayments,
            status: myData.reqStatus,
            createdAt: new Date().toISOString()
        };
    };

    const sendWhatsappMessage = (paymentRow) => {
        const totalAmountPaid = getAmountPaidTotal(paymentRows);
        if (!requestDataRow || !paymentRow) return "";

        const message = `
            مرحبــا, ${requestDataRow.reqClientName}

            هـذه رسالة تـأكـيـد تـحـصــيـل دفعة
            لمسلسل حجز رقم : ${requestDataRow.reqCode}
            لوحدة رقم ${requestDataRow.unit?.unitCode} من يــوم ${moment(requestDataRow.reqFrom).format("DD/MM/YYYY")}

            القيمة المحصلة ${totalAmountPaid}ج.م. القيمة المتبقية${requestDataRow.reqTotalCost - totalAmountPaid}ج.م.
        `;
        return encodeURIComponent(message);
    }

    function getAmountPaidTotal(payments) {
        let total = 0;
        payments?.forEach((ele) => {
            if (ele.paymentType === "deposit") {
                total += parseFloat(ele.amountPaid);
            } else if (ele.paymentType === "refund") {
                total -= parseFloat(ele.amountPaid);
            }
        });
        return total;
    }

    useEffect(() => {
        let myData = requestDataRow ? { ...requestDataRow } : {};
        const oldestPaymentIds = [];
        if (myData?.reqPayments?.length) {
            const reqPaymentList = myData?.reqPayments?.map((ele, i) => {
                oldestPaymentIds.push(i);
                return {
                    id: i,
                    paymentType: ele.paymentType,
                    paymentMethod: ele.paymentMethod,
                    amountPaid: ele.amountPaid,
                    referenceNumber: ele.referenceNumber,
                    createdAt: ele.createdAt,
                    paymentId: ele.paymentId
                };
            });
            setOldestPayment(oldestPaymentIds);
            setPaymentRows(reqPaymentList);
            myData["reqPayments"] = reqPaymentList;
            setRequestDataRow(myData);
            handleChange({}, "reqPayments", reqPaymentList);
        }
    }, []);

    useEffect(() => {
        if (paymentRows.length && paymentRows[0]?.paymentMethod) {
            const data = paymentRows.map((ele, i) => {
                return {
                    paymentType: ele.paymentType,
                    paymentMethod: ele.paymentMethod,
                    amountPaid: ele.amountPaid,
                    referenceNumber: ele.referenceNumber,
                    createdAt: ele.createdAt || moment().toISOString(),
                    paymentId: ele.paymentId,
                };
            });
            handleChange({}, "reqPayments", data);
        }
    }, [paymentRows])

    useEffect(() => {
        if (clearPaymentRows) {
            setPaymentRows([
                {
                    id: 1,
                    paymentType: "",
                    paymentMethod: "",
                    amountPaid: 0,
                    referenceNumber: "",
                    createdAt: moment().toISOString(),
                }
            ])
        }
    }, [clearPaymentRows])


    return (
        <>
            {paymentRows?.map((ele, i) => (
                <ul className='col-12 row align-items-end' key={i}>
                    <li className="col-md-3 col-6">
                        <div className='py-2 px-2'>
                            <FormControl className='textfield-input' variant="standard" >
                                <InputLabel id="demo-simple-select-standard-label">{t("paymentType")}</InputLabel>
                                <Select
                                    readOnly={oldestPayment.includes(ele.id) ? true : false}
                                    MenuProps={{ disableScrollLock: true }}
                                    labelId="demo-simple-select-standard-label"
                                    id="paymentType"
                                    value={ele.paymentType}
                                    onChange={(e) => handlePaymentTypeChange(e, ele.id)}
                                >
                                    <MenuItem value={"deposit"}>{t("depositPaymentType")}</MenuItem>
                                    {requestDataRow ? <MenuItem value={"refund"}>{t("refund")}</MenuItem> : null}
                                </Select>
                            </FormControl>
                        </div>
                        <div className="text-helper-invalid d-none">{t("pleaseSelectAPaymentMethod")}</div>
                    </li>
                    <li className="col-md-3 col-6">
                        <div className='py-2 px-2'>
                            <FormControl className='textfield-input' variant="standard" >
                                <InputLabel id="demo-simple-select-standard-label">{t("paymentMethod")}</InputLabel>
                                <Select
                                    readOnly={oldestPayment.includes(ele.id) ? true : false}
                                    MenuProps={{ disableScrollLock: true }}
                                    labelId="demo-simple-select-standard-label"
                                    id="paymentMethod"
                                    value={ele.paymentMethod}
                                    onChange={(e) => handlePaymentMethodChange(e, ele.id)}
                                >
                                    <MenuItem value={"bankTransfer"}>{t("bankTransfer")}</MenuItem>
                                    <MenuItem value={"egyptianPost"}>{t("egyptianPost")}</MenuItem>
                                    <MenuItem value={"wallet"}>{t("wallet")}</MenuItem>
                                    <MenuItem value={"cash"}>{t("cash")}</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div className="text-helper-invalid d-none">{t("pleaseSelectAPaymentMethod")}</div>
                    </li>
                    {
                        ele?.paymentMethod && ele?.paymentType && <>
                            <li className="col-md-3 col-6">
                                <div className='py-2 px-2' >
                                    <FormControl fullWidth variant="standard">
                                        <InputLabel htmlFor="standard-adornment-amount">{t("amountPaid")}</InputLabel>
                                        <Input
                                            readOnly={oldestPayment.includes(ele.id) ? true : false}
                                            type='number'
                                            id="amountPaid"
                                            onChange={(e) => handleAmountPaidChange(e, ele.id)}
                                            value={ele.amountPaid}
                                            endAdornment={<InputAdornment position="end"> {t("EGP")} </InputAdornment>}
                                        />
                                    </FormControl>
                                </div>
                                <div className="text-helper-invalid d-none">{t("pleaseEnterTheAmountPaid")}</div>
                            </li>
                            <li className="col-md-2 col-5">
                                <div className='py-2 px-2' >
                                    <FormControl fullWidth variant="standard">
                                        <InputLabel htmlFor="standard-adornment-amount">{t("referenceNumber")}</InputLabel>
                                        <Input
                                            type='text'
                                            id="referenceNumber"
                                            onChange={(e) => handleReferenceNumberChange(e, ele.id)}
                                            value={ele.referenceNumber}
                                        />
                                    </FormControl>
                                </div>
                                <div className="text-helper-invalid d-none">{t("pleaseEnterTheReferenceNumber")}</div>
                            </li>
                        </>
                    }
                    <li className='col-1 d-flex justify-content-center'>
                        {requestDataRow && <button disabled={paymentRows.length >= 1 ? false : true} variant="text" className={'text-myPrimary fs-6 px-1 mx-0'} onClick={() => { setShowPrintModal(true); ele.paymentType === "deposit" ? setSelectedDeposit(ele) : setSelectedRefund(ele); setPrintType(ele.paymentType); }}><FontAwesomeIcon icon={faPrint} /></button>}
                        {requestDataRow &&
                            <button disabled={paymentRows.length >= 1 ? false : true} variant="text" className={'text-myPrimary fs-6 px-1 mx-0'}>
                                <a className='mx-2' target='_blank' href={`https://wa.me/${requestDataRow.client?.clientPhone || requestDataRow.rentingUser?.phoneNumber}?text=${sendWhatsappMessage(ele)}`}>
                                    <FontAwesomeIcon className=' cursor-pointer fs-5 text-success' icon={faWhatsapp} />
                                </a>
                            </button>
                        }
                        {!oldestPayment.includes(ele.id) && <button disabled={paymentRows.length > 1 && paymentRows.length == i + 1 ? false : true} variant="text" className={'text-danger fs-6 px-1 mx-0'} onClick={() => deleteRow(ele.id)}><FontAwesomeIcon icon={faTrash} /></button>}
                    </li>
                </ul>
            ))}
            <div className='pe-3'>
                <div className='requestPaymentsError fs-6 text-danger d-none'>برجاء ادخال البيانات</div>
                <span
                    className="text-myPrimary cursor-pointer mb-2"
                    onClick={addNewReqPayment}
                >
                    <span className='text'>+</span> اضافة ايداع / استرجاع
                </span>
            </div>
            {requestDataRow && <PrintReceiptModal
                isOpen={showPrintModal}
                onClose={() => setShowPrintModal(false)}
                type={printType}
                request={getBookingRequestForPrint()}
                deposit={selectedDeposit || undefined}
                refund={selectedRefund || undefined}
            />}
        </>
    )
}
